import { getTokenStorage, getHttpClient } from './http-client.factory';
import { HttpAuthRepository } from '../../infrastructure/repositories/http-auth.repository';
import { LoginUserUseCase } from '../../application/use-cases/login-user.use-case';
import { LogoutUserUseCase } from '../../application/use-cases/logout-user.use-case';
import { GetCurrentSessionUseCase } from '../../application/use-cases/get-current-session.use-case';

export interface AuthUseCases {
  loginUserUseCase: LoginUserUseCase;
  logoutUserUseCase: LogoutUserUseCase;
  getCurrentSessionUseCase: GetCurrentSessionUseCase;
}

export const makeAuthUseCases = (): AuthUseCases => {
  const tokenStorage = getTokenStorage();
  const httpClient = getHttpClient();
  const authRepository = new HttpAuthRepository(httpClient);

  // 4. Casos de uso
  const loginUserUseCase = new LoginUserUseCase(authRepository, tokenStorage);
  const logoutUserUseCase = new LogoutUserUseCase(tokenStorage);
  const getCurrentSessionUseCase = new GetCurrentSessionUseCase(tokenStorage);

  return {
    loginUserUseCase,
    logoutUserUseCase,
    getCurrentSessionUseCase,
  };
};
